<template>
  <div class="allBox">
    <div class="header">
      <a-button @click="btnAllNews" type="primary">
        添加新闻
      </a-button>
    </div>
    <div class="content">
      <a-table
        tableLayout="fixed"
        :data-source="newsList"
        :rowKey="newsList => newsList.id"
        :loading="dataLoding"
        :pagination="{
          total: total,
          pageSize: pageSize,
          current: current,
          showTotal: total =>
            $t('public.page', { total: total, pageSize: pageSize }),
          onChange: currentChange
        }"
      >
        <a-table-column title="新闻标题" :ellipsis="true" dataIndex="title">
        </a-table-column>
        <a-table-column
          :ellipsis="true"
          title="更新时间"
          dataIndex="updateTime"
        >
        </a-table-column>
        <a-table-column title="发布时间" dataIndex="createTime">
        </a-table-column>
        <a-table-column title="状态" dataIndex="status">
          <template slot-scope="status">
            {{ status == 0 ? '待发布' : '已发布' }}
          </template>
        </a-table-column>
        <a-table-column title="操作" dataIndex="operation">
          <template slot-scope="id, newsList">
            <a-popconfirm
              v-if="newsList.status == 1"
              title="确定撤回?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="btnWithdraw(newsList.id)"
            >
              <a>撤回</a>
              <div class="border"></div>
            </a-popconfirm>
            <a-popconfirm
              v-if="newsList.status == 0"
              title="确定发布?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="btnRelease(newsList.id)"
            >
              <a>发布</a>
              <div class="border"></div>
            </a-popconfirm>
            <a-popconfirm
              title="确定删除?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="btnDelect(newsList.id)"
            >
              <a>删除</a>
            </a-popconfirm>
            <div class="border"></div>
            <a @click="btnTop(newsList.id)">置顶</a>
            <div class="border"></div>
            <a @click="() => btnEdit(newsList.id)">编辑</a>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      title="添加新闻"
      v-model="visibleAdd"
      :confirm-loading="confirmLoading"
      @ok="AddhandleOk"
    >
      <a-form
        :form="modelForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        @submit="handleSubmit"
      >
        <a-form-item label="新闻标题">
          <a-input
            placeholder="请输入课程名称"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入课程名称' }]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visibleAdd: false,
      newsList: [],
      total: 0,
      pageSize: 10,
      current: 1,
      dataLoding: false,
      confirmLoading: false,
      modelForm: this.$form.createForm(this, {
        name: 'modelForm'
      })
    }
  },
  created() {
    this.getNewsData()
  },
  methods: {
    btnRelease(id) {
      let data = {
        status: 1,
        id
      }
      this.$http(this.$api.UPDATENEWS, data).then(() => {
        this.$notification['success']({
          message: '撤回新闻',
          description: '撤回成功'
        })
        this.getNewsData()
      })
    },
    currentChange(val) {
      this.current = val
      this.getNewsData()
    },
    getNewsData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.current
      }
      this.$http(this.$api.GETNEWSDATA, data).then(r => {
        this.newsList = r.data.records
      })
    },
    //撤回
    btnWithdraw(id) {
      let data = {
        status: 0,
        id
      }
      this.$http(this.$api.UPDATENEWS, data).then(() => {
        this.$notification['success']({
          message: '撤回新闻',
          description: '撤回成功'
        })
        this.getNewsData()
      })
    },
    //置顶
    btnTop(id) {
      this.$http(this.$api.TOPNEWITEM, {
        id
      }).then(() => {
        this.$notification['success']({
          message: '置顶新闻',
          description: '置顶成功'
        })
        this.getNewsData()
      })
    },
    btnDelect(id) {
      this.$http(this.$api.DELECTNEWITEM, {
        id
      }).then(() => {
        this.$notification['success']({
          message: '删除新闻',
          description: '删除成功'
        })
        this.getNewsData()
      })
    },
    btnEdit(id) {
      this.$router.push({
        name: 'editNews',
        params: {
          id: id
        }
      })
    },
    //添加新闻
    btnAllNews() {
      this.visibleAdd = true
    },
    AddhandleOk() {
      this.handleSubmit()
    },
    handleSubmit() {
      this.confirmLoading = true
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          //添加新闻与后端约定 添加的时候status传入0
          data.status = 0
          this.$http(this.$api.ADDNEWSITEM, data).then(() => {
            this.confirmLoading = false
            this.visibleAdd = false
            this.getNewsData()
            this.$notification['success']({
              message: '添加新闻',
              description: '新闻添加成功'
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.allBox {
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  .header {
    padding: 20px 0 0 20px;
    height: 80px;
  }
  .content {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}
</style>
